
const IMG_URL = process.env.REACT_APP_IMG_URL;
export default IMG_URL;
